<ng-container *ngIf="status$ | async as status">
  <ng-container *ngIf="status !== 'closed'">
    <div class="notification-area shadow dock-{{dockMode}}" *transloco="let t; read: 'mes.notification-area'">
      <div class="modal-header rounded-top p-0 bg-dark text-light">
        <div class="modal-title ps-1" ngbDropdown role="group" display="dynamic" placement="top-left" container="null">
          <button class="btn p-0 text-light" ngbDropdownToggle (click)="changeDetector.detectChanges()">
            <svg viewBox="0 0 8 8" class="icon small text-light" [inlineSVG]="'#bars-3'">
            </svg>
            {{ t('Notifications') }}
            <span *ngIf="hasUnreadMark" class="text-warning">*</span>
          </button>
          <div class="dropdown-menu" ngbDropdownMenu>
            <button ngbDropdownItem class="px-3" (click)="dockMode = 'left'">
              <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#chevron-double-left'">
              </svg>
              {{ t('Dock left') }}
            </button>
            <button ngbDropdownItem class="px-3" (click)="dockMode = 'right'">
              <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#chevron-double-right'">
              </svg>
              {{ t('Dock right') }}
            </button>
            <button ngbDropdownItem class="px-3" [class.active]="showMemoryUsage" (click)="showMemoryUsage = !showMemoryUsage">
              <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#cpu-chip'">
              </svg>
              {{ t('Memory Usage') }}
            </button>
            <button ngbDropdownItem class="px-3" (click)="initializePage()">
              <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#trash'">
              </svg>
              {{ t('Clear notifications') }}
            </button>
            <button ngbDropdownItem class="px-3" (click)="testMessage()">
              <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#chat-bubble-left-right'">
              </svg>
              {{ t('Test connection') }}
            </button>
            <ng-container>
              <div class="dropdown-divider"></div>
              <h6 class="dropdown-header">{{ t('Pending tasks') }}</h6>
              <button ngbDropdownItem class="px-3" (click)="cancel(pendingTask.id)" *ngFor="let pendingTask of pendingTasks; let index = index" title="{{pendingTask.id}}">
                <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#x-mark'">
                </svg>
                {{ index + 1 }}. {{ pendingTask.text }}
              </button>
              <button ngbDropdownItem class="px-3" (click)="clearPending()">
                <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#exclamation-triangle'">
                </svg>
                {{ t('Clear pending list') }}
              </button>
            </ng-container>
          </div>
        </div>
        <span class="ms-auto">
        <help-button *transloco="let h" [key]="h('help.common.notification-area')"/>
          <span class="pe-2" *ngIf="memoryUsage">
            RAM: {{ memoryUsage | number: '1.1-1' }}%
          </span>

        <button type="button" class="btn p-0 pe-1" (click)="toggleStatus()">
          <svg viewBox="0 0 8 8" class="icon small text-light" [inlineSVG]="status === 'minimized' ? '#stop' : '#minus'">
          </svg>
        </button>
        <button type="button" class="btn p-0 pe-1" (click)="status$.next('closed'); changeDetector.detectChanges()" aria-label="Close">
          <svg viewBox="0 0 8 8" class="icon small text-light" [inlineSVG]="'#x-mark'">
          </svg>
        </button>
      </span>
      </div>
      <div *ngIf="status === 'maximized'" class="opened border-start border-end bg-gray-100 message-area" (scroll)="onScroll($event)" id="message-area">
        <div *ngIf="page.Number !== 0" class="my-2 d-flex" style="width: 287px">
          <a class="flex-fill me-1 badge bg-white text-decoration-none text-primary" (click)="showPrevious()">
            <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#ellipsis-horizontal'">
            </svg>
            {{ t('previous') }}
          </a>
          <a class="flex-fill ms-1 badge bg-white text-decoration-none text-primary" (click)="showAll()">
            {{ t('All') }} ({{ page.Total }})
          </a>
        </div>
        <div *ngFor="let message of messages | pager: page : true; trackBy: trackByTimeStamp" class="bg-white rounded-1 mb-1" style="width: 287px" [ngClass]="message.logLevel | notificationStatusColor">
          <span *ngIf="message.isCanceled" class="badge bg-warning ms-1">{{ t('CANCELED') }}</span>
          <a ngbDropdown role="group" display="dynamic" container="null">
            <a class="badge bg-primary text-wrap text-decoration-none text-white mx-1 px-1" ngbDropdownToggle (click)="changeDetector.detectChanges()" title="{{message.taskId}}">
              {{ message.task }}
            </a>
            <a class="dropdown-menu" ngbDropdownMenu>
              <button ngbDropdownItem class="px-3" [ngClass]="message.taskId ? 'text-danger' : 'text-muted'" (click)="cancel(message.taskId)" [disabled]="!message.taskId">
                <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#x-mark'">
                </svg>
                {{ t('Abort task') }}
              </button>
            </a>
          </a>
          <small class="text-muted">{{ message.timestamp | date: 'mediumTime' }}</small>
          <div class="text-pre text-break mx-1" [class.text-muted]="message.isCanceled">{{ message.info }}</div>
          <div class="text-pre text-break mx-1 text-muted fs-3 fst-italic" *ngIf="showMemoryUsage && message.memory">RAM: {{ (message.memory?.mb / message.memory?.total * 100) | number: '1.1-1' }}% ({{message.memory.mb | number: '2.2-2'}} MB of {{message.memory.total | number: '2.2-2'}} MB)</div>
        </div>
        <div *ngIf="page.Number + 1 !== page.Pages && page.Pages > 1" class="my-2 d-flex" style="width: 287px" id="next-button">
          <a class="flex-fill me-1 badge bg-white text-decoration-none text-primary" (click)="showAll()">
            {{ t('All') }} ({{ page.Total }})
          </a>
          <a class="flex-fill ms-1 badge bg-white text-decoration-none text-primary" (click)="showNext()">
            {{ t('Next') }}
            <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#ellipsis-horizontal'">
            </svg>
          </a>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
